import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { LineItem } from 'services/checkout-service/models';
import { fromCentsWithLocale } from 'utils/Currency';
import { useCheckoutCurrency } from 'hooks/context/checkoutSession';

import { LINE_ITEMS_TEST_IDS, getListItemTestId } from './const';

import styles from './styles.module.scss';

type LineItemsProps = {
  lineItems?: LineItem[];
};

export const LineItems: FC<LineItemsProps> = ({ lineItems }) => {
  const { t } = useTranslation();
  const currency = useCheckoutCurrency();

  if (!lineItems) return null;

  return (
    <ul className={styles.lineItemsWrapper} data-testid={LINE_ITEMS_TEST_IDS.list}>
      {lineItems.map(({ name, price, unitQty }) => (
        <li key={name} data-testid={getListItemTestId(name)}>
          <p className={styles.lineItemRow}>
            <span className={styles.name}>
              {t('lineItem.name', { name, count: unitQty })}
            </span>

            <span className={styles.amount}>
              {t('money', { amount: fromCentsWithLocale(price * unitQty, currency) })}
            </span>
          </p>
        </li>
      ))}
    </ul>
  );
};
